'use strict';
import angular from 'angular';
import metricSelectHtmlUrl from './views/metricSelect.html';
import _ from "lodash";

var app = angular.module('app.metricSelect', []);

app.component('metricSelect', {
    bindings: {
        metricSelection: '=',
        modelValue : '=',
        showActions : '=',
        form : '<'
    },
    templateUrl: metricSelectHtmlUrl,

    controller: function($scope, $ioAlert, FormService) {
        const DATASOURCE_SERVICE = 'Service';
        const DATASOURCE_SMART_CAMPAIGN = 'SmartCampaign';

        var self = this;
        self.dataObj = null;
        self.datasources = [DATASOURCE_SERVICE, DATASOURCE_SMART_CAMPAIGN];
        self.metrics = null;
        self.services = null;
        self.smartcampaigns = null;
        self.showServices = false;
        self.showSmartCampaigns = false;
        self.showMetrics = false;
        self.showDataViews = false;
        self.showButtons = false;
        self.preselectedServiceId = null;
        self.preselectedSmartCampaignId = null;
        self.preselectedMetricName = null;
        self.preselectedDataViewName = null;
        self.suppressButtons = false;

        $scope.$watch('$ctrl.dataObj.datasource', function(selectedVal) {
            if (!selectedVal) {
                self.clearMetricSelection();
            } else if (selectedVal === DATASOURCE_SERVICE) {
                if (!self.services) {
                    loadGoalServices();
                }
                self.showServices = true;
                self.showSmartCampaigns = false;
                self.showMetrics = false;
                self.showDataViews = false;
                self.showButtons = false;
                self.dataObj.smartcampaign = null;
                self.dataObj.metric = null;
            } else if (selectedVal === DATASOURCE_SMART_CAMPAIGN) {
                if (!self.smartcampaigns) {
                    loadSmartCampaigns();
                }
                self.showServices = false;
                self.showSmartCampaigns = true;
                self.showMetrics = false;
                self.showDataViews = false;
                self.showButtons = false;
                self.dataObj.service = null;
                self.dataObj.metric = null;
            }
        });

        $scope.$watch('$ctrl.dataObj.service', function(selectedVal) {
            if (selectedVal) {
                loadServiceMetrics(selectedVal.id);
                loadServiceDataViews(selectedVal.id);
                self.showMetrics = true;
                self.showDataViews = true;
            } else {
                self.dataObj.metric = null;
                self.showMetrics = false;
                self.showDataViews = false;
                self.showButtons = false;
            }
        });

        $scope.$watch('$ctrl.dataObj.smartcampaign', function(selectedVal) {
            if (selectedVal) {
                loadServiceMetrics(selectedVal.service_id);
                loadServiceDataViews(selectedVal.service_id);
                self.showMetrics = true;
                self.showDataViews = true;
            } else {
                self.dataObj.metric = null;
                self.showMetrics = false;
                self.showDataViews = false;
                self.showButtons = false;
            }
        });

        $scope.$watch('$ctrl.dataObj.metric', function(selectedVal) {
            if (selectedVal) {
                self.showButtons = !self.suppressButtons;
                self.suppressButtons = false;
            } else {
                self.showButtons = false;
                self.dataObj.metric = null;
            }
        });

        $scope.$watch('$ctrl.dataObj.dataview_id', function(selectedVal) {
            if (selectedVal) {
                self.showButtons = !self.suppressButtons;
                self.suppressButtons = false;
            } else {
                self.showButtons = false;
                self.dataObj.metric = null;
            }
        });

        function newDataObj() {
            let dataObj = {};
            dataObj.datasource = null;
            dataObj.service = null;
            dataObj.smartcampaign = null;
            dataObj.metric = null;
            return dataObj;
        }

        function loadGoalServices() {
            FormService.getGoalServices().then(function(resource) {
                if (resource.data && resource.data.length !== 0) {
                    self.services = resource.data;

                    if (self.preselectedServiceId) {
                        let serviceObj = _.find(self.services, {id: self.preselectedServiceId});
                        if (serviceObj) {
                            self.dataObj.service = serviceObj;
                            loadServiceMetrics(self.preselectedServiceId);
                            loadServiceDataViews(self.preselectedServiceId);
                        }
                    }
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        function loadSmartCampaigns() {
            FormService.getSmartCampaigns().then(function(resource) {
                if (resource.data && resource.data.length !== 0) {
                    self.smartcampaigns = resource.data;

                    if (self.preselectedSmartCampaignId) {
                        let smartcampaignObj = _.find(self.smartcampaigns, {id: self.preselectedSmartCampaignId});
                        if (smartcampaignObj) {
                            self.dataObj.smartcampaign = smartcampaignObj;
                            loadServiceMetrics(self.dataObj.smartcampaign.service_id);
                            loadServiceDataViews(self.dataObj.smartcampaign.service_id);
                        }
                    }
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        function loadServiceMetrics(serviceId) {
            FormService.getServiceMetrics(serviceId).then(function(resource) {
                if (resource.metadata && resource.metadata.columns && resource.metadata.columns.length !== 0) {
                    self.metrics = resource.metadata.columns;

                    if (self.preselectedMetricName) {
                        let metricObj = _.find(self.metrics, {field: self.preselectedMetricName});
                        if (metricObj) {
                            self.suppressButtons = true;
                            self.dataObj.metric = metricObj;
                        }
                    }
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        function loadServiceDataViews(serviceId) {
            FormService.getServiceDataViews(serviceId).then(function(resource) {
                if (resource.data) {
                    self.dataViews = resource.data;

                    if (self.preselectedDataViewName) {
                        let dataViewObj = _.find(self.dataViews, {id: self.preselectedDataViewName});
                        if (dataViewObj) {
                            self.suppressButtons = true;
                            self.dataObj.dataview_id = dataViewObj.id;
                        }
                    }
                }
            }, function() {
                $ioAlert.show('Error!', 'Something went wrong here. Please refresh the page to try again', 'error');
            });
        }

        function harvestMetricSelection() {
            let serviceObject = (self.dataObj.service) ? self.dataObj.service : self.dataObj.smartcampaign;
            self.metricSelection = {};
            self.metricSelection.datasource = self.dataObj.datasource;
            self.metricSelection.service_id = serviceObject.id;
            self.metricSelection.metric_column = self.dataObj.metric.field;
            self.metricSelection.metric_format = self.dataObj.metric.format;
            self.metricSelection.dataview_id = self.dataObj.dataview_id;
        }

        self.saveMetricSelection = function() {
            harvestMetricSelection();
            self.showButtons = false;
        };

        self.clearMetricSelection = function() {
            self.showServices = false;
            self.showSmartCampaigns = false;
            self.showMetrics = false;
            self.showButtons = false;
            self.dataObj = newDataObj();
        };

        self.initComponent = function() {
            if (self.metricSelection) {
                self.metricSelection = JSON.parse(self.metricSelection);
                self.preselectedMetricName = self.metricSelection.metric_column;
                self.preselectedDataViewName = self.metricSelection.dataview_id;

                if (self.metricSelection.datasource === DATASOURCE_SERVICE) {
                    self.preselectedServiceId = self.metricSelection.service_id;
                } else if (self.metricSelection.datasource === DATASOURCE_SMART_CAMPAIGN) {
                    self.preselectedSmartCampaignId = self.metricSelection.service_id;
                }

                self.dataObj = newDataObj();
                self.dataObj.datasource = self.metricSelection.datasource;
            } else {
                self.dataObj = newDataObj();
                self.metricSelection = {};
            }
        };

        self.initComponent();
    }
});